import { resolveUrl, default as stipulate } from "stipulate";
import credentialTypes from "../constants/credentials";
import extractTypes from "../constants/extract-types";

const requestUtility = {
  get(url, query, credentials = credentialTypes.INCLUDE) {
    const urlWithQuery = resolveUrl(url, query);
    const requestOptions = {
      credentials,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "GET",
    };

    return stipulate(urlWithQuery, requestOptions);
  },
  post(url, data = {}, credentials = credentialTypes.INCLUDE) {
    const requestOptions = {
      credentials,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    };

    return stipulate(url, requestOptions);
  },
  delete(
    url,
    credentials = credentialTypes.INCLUDE,
    extract = extractTypes.JSON
  ) {
    const requestOptions = {
      credentials,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "DELETE",
    };

    return stipulate(url, requestOptions, extract);
  },
  put(url, data = {}, credentials = credentialTypes.INCLUDE) {
    const requestOptions = {
      credentials,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "PUT",
      body: JSON.stringify(data),
    };

    return stipulate(url, requestOptions);
  },
};

export default requestUtility;
